import React, { useEffect } from 'react';
import { bool, number, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import './video-player.scss';

export const VideoPlayer = ({
  autoPlay, className, videoId
}) => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('video-player.ready');
  });

  const classes = classNames('video-player', className);
  let iframeSrc = `https://players.brightcove.net/66036796001/4JE-ofbdg_default/index.html?videoId=${videoId}`;
  iframeSrc += autoPlay ? '&autoplay=any' : '';
  return (
    <iframe
      className={classes}
      src={iframeSrc}
      title={videoId}
      allowFullScreen
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    />
  );

};

VideoPlayer.propTypes = {
  autoPlay: bool,
  className: string,
  videoId: oneOfType([
    string,
    number,
  ]).isRequired,
};

VideoPlayer.defaultProps = {
  autoPlay: false,
  className: null
};
